import React from 'react';

type Anchor = {
  nativeId?: string;
  aRef: React.RefObject<any>;
  focusOn?: React.RefObject<any>;
  offset?: number;
};

export type ScrollContextType = {
  anchors: Anchor[];
  scrollMode: 'auto' | 'disabled';
  scrollContainerRef?: React.RefObject<any>;
};

const ScrollContext = React.createContext<ScrollContextType>({
  anchors: [],
  scrollMode: 'auto',
  scrollContainerRef: React.createRef<any>(),
});

export default ScrollContext;
